import { SmartShape } from "appworks/graphics/elements/smart-shape";
import { Layers } from "appworks/graphics/layers/layers";
import { SkipAreaControl } from "./skip-area-control";

export class MatrixSkipAreaControl extends SkipAreaControl {
    constructor() {

        const matrixLayer = Layers.get("MatrixContent");
        const skipLayer = Layers.get("Skip");

        const area = new SmartShape();
        area.name = "skipArea";
        area.shapeFillColor = 0xff0000;
        area.landscape = matrixLayer.bounds.landscape.clone();
        area.portrait = matrixLayer.bounds.portrait.clone();

        // Global to local
        area.landscape.subtract(skipLayer.container.landscape);
        area.portrait.subtract(skipLayer.container.portrait);

        skipLayer.add(area);

        super(area);
    }
}
